import * as actionTypes from './ActionTypes';
// import * as constants from 'Constants';
// import authActions from 'Store/UserInfo/Actions';
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';
import httpService from 'services/httpService';
import log from "loglevel";

export const loadCourseGroupsRequest = (courseid) => {
    return async (dispatch) => {
        const url = `/courseware/api/course/${courseid}/groups/?format=json`;
        try {
            if (!courseid && (courseid !== '0' || courseid !== 0)) {
                throw new Error("courseid is ", courseid);
            }
            log.log("Hello Axios", httpService.defaults);
            const response = await httpService.get(url);
            log.log(response);
            let groups = response.data;
            groups?.sort((a, b) => a.id > b.id ? 1 : -1);
            log.log(groups);
            // alert();
            dispatch(loadCourseGroupsSuccess(courseid, groups));
        } catch (error) {
            log.log(error);
            displayGlobalMessage("Group Loading Failed", "error");
            throw error;
            // dispatch(authFail(err));
        }
    }
}

export const loadCourseGroupsSuccess = (courseid, groups) => {
    return {
        type: actionTypes.LOAD_STUDENT_COURSE_GROUPS_SUCCESS,
        courseid,
        groups
    }
}

export const loadGroupConceptsRequest = (groupid) => {
    return async (dispatch) => {
        if (!groupid && (groupid !== '0' || groupid !== 0)) {
            log.log("Groupid is falsy: ", groupid, " hence, not proceeding with loadGroupConceptsRequest");
        } else {
            const url = `/courseware/api/group/${groupid}/concepts/?format=json`;
            try {
                log.log("Hello Axios", httpService.defaults);
                const response = await httpService.get(url);
                log.log(response);
                const concepts = response.data;
                // alert();
                dispatch(loadGroupConceptsSuccess(groupid, concepts));
            } catch (error) {
                log.log(error);
                displayGlobalMessage("Concepts Loading Failed", "error");
                // throw error;
                // dispatch(authFail(err));
            }
        }
    }
}

export const loadGroupConceptsSuccess = (groupid, concepts) => {
    return {
        type: actionTypes.LOAD_STUDENT_GROUP_CONCEPTS_SUCCESS,
        groupid,
        concepts
    }
}



// load req
export const loadConceptDataRequest = (conceptId) => {
    return async (dispatch) => {
        const url = `/concept/api/concept/${conceptId}/get_concept_page_data/`;
        try {
            log.log("Hello Axios", httpService.defaults);
            const response = await httpService.get(url);
            log.log(response);
            const data = response.data;
            // alert();
            dispatch(loadConceptDataSuccess(conceptId, data));
        } catch (error) {
            log.log(error);
            displayGlobalMessage('Concept Data Loading failed', 'error');
            throw error;
            // dispatch(authFail(err));
        }
    }
}

export const loadConceptDataSuccess = (conceptId, data) => {
    return {
        type: actionTypes.LOAD_STUDENT_CONCEPT_DATA_SUCCESS,
        conceptId,
        data
    }
}

export const register_to_course = async (courseId) => {
    const url = `/courseware/api/course/${courseId}/register/`;
    try {
        const response = await httpService.post(url);
        if (response.status === 200 || response.status === 202) {
            return response.data;
        }
    } catch (error) {
        log.log(error);
        if (error.response && error.response.data && typeof error.response.data === "string") {
            displayGlobalMessage(`Course Enrollment failed: ${error.response.data}`, 'error');
        } else {
            displayGlobalMessage('Course Enrollment failed', 'error');
        }
        throw error;
        // dispatch(authFail(err));
    }
}

export const unregister_course_request = async (courseId) => {
    const url = `/courseware/api/course/${courseId}/deregister/`;
    try {
        const response = await httpService.post(url);
        if (response.status === 200) {
            displayGlobalMessage(
                "The course was successfully unenrolled",
                "success"
            );
            return response.data;
        } else {
            displayGlobalMessage(response.data["message"], "error");
            return false;
        }
    } catch (error) {
        displayGlobalMessage("The course could not be unenrolled", "error");
        log.error(error)
        return false;
        // throw error;
    }
}

export const registration_data = async (courseId) => {
    const url = `/courseware/api/course/${courseId}/registration_data/`;
    try {
        const response = await httpService.post(url);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        log.log(error);
        if (error?.response?.status !== 404) {
            displayGlobalMessage('Course enrollment data fetching failed. Please logout and login again.', 'error');
        }
        throw error;
        // dispatch(authFail(err));
    }
}

export const getFullCourseDetails = async (courseId) => {
    const url = `/courseware/api/course/${courseId}/get_full_course_detail/`;
    try {
        const response = await httpService.get(url);
        return response;
    } catch (error) {
        log.log({ "Full course detail api failed": error });
        displayGlobalMessage('Full course detail api failed', 'error');
        throw error;
    }
}

